import { AxiosError } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorInfo } from '../../../../../../api/model';
import { useGetSection, usePostSectionLock, usePostSectionUnlock } from '../../../../../../api/sections/sections';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  sectionId: number;
  isLock: boolean; // true:編集状態
  isOwnLock: boolean; // 自身の編集
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  setSectionId: (sectionId: number) => void;
  setContextOpen: (isOpen: boolean) => void;
  onSearch: () => void;
  setSecReading: (secReading: boolean) => void;
};
function SectionTreeMenuEdit({
  sectionId,
  isLock,
  isOwnLock,
  setSectionId,
  setContextOpen,
  onSearch,
  isEdit,
  setIsEdit,
  setSecReading,
}: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const {
    mutateAsync: lockMutate,
    isLoading: isLoadinglock,
    isSuccess: isSuccesslock,
    isError: isErrorLock,
    error: Errorlock,
  } = usePostSectionLock<AxiosError<ErrorInfo>, unknown>(options);
  const {
    mutateAsync: unlockMutate,
    isLoading: isLoadingUnlock,
    isSuccess: isSuccessUnlock,
    isError: isErrorUnLock,
    error: ErrorUnlock,
  } = usePostSectionUnlock<AxiosError<ErrorInfo>, unknown>(options);

  const [displayLockError, setDisplayLockError] = useState(false);
  const [displayUnLockError, setDisplayUnLockError] = useState(false);

  // Sticky panel
  const changeEditModeStatus = useRef<string>('none');
  const timerRef = useRef<NodeJS.Timer | null>(null);
  const reshowCkeditorStickyPanel = () => {
    if (changeEditModeStatus.current !== 'started') {
      return;
    }
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(() => {
      const placeholderElement = document.querySelector('.ck-sticky-panel__placeholder');
      const styleDisplay = window.getComputedStyle(placeholderElement as Element).display;
      if (placeholderElement && styleDisplay === 'none') {
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        const scrollEvent = new Event('scroll');
        window.dispatchEvent(scrollEvent);
        changeEditModeStatus.current = 'none';
      }
    }, 1000);
  };

  const handleLock = async () => {
    changeEditModeStatus.current = 'started';
    await lockMutate({
      sectionId,
    });
    reshowCkeditorStickyPanel();
  };

  const handUnleLock = async () => {
    if (window.confirm('保存していませんが、よろしいでしょうか？')) {
      setIsEdit(false);
      changeEditModeStatus.current = 'started';
      await unlockMutate({
        sectionId,
      });
      reshowCkeditorStickyPanel();
    }
  };
  const { refetch } = useGetSection(sectionId, options); // ← 恐らく不要

  useEffect(() => {
    if (isSuccesslock) {
      setSecReading(true);
      setSectionId(sectionId);
      void refetch(); // ← 恐らく不要
      onSearch(); // ← 恐らく不要（再読込みせずツリーの状態を変えられれば）※ツリー再読込みに時間が掛かるため
      setContextOpen(false);
    }
  }, [isSuccesslock, setSectionId, setContextOpen, sectionId, onSearch, refetch, setSecReading]);

  useEffect(() => {
    if (isSuccessUnlock && !isLoadingUnlock) {
      if (isOwnLock) {
        setSecReading(true);
      }
      setSectionId(sectionId);
      void refetch(); // ← 恐らく不要
      onSearch(); // ← 恐らく不要（再読込みせずツリーの状態を変えられれば）※ツリー再読込みに時間が掛かるため
      setContextOpen(false);
    }
  }, [
    isSuccessUnlock,
    isLoadingUnlock,
    setSectionId,
    setContextOpen,
    sectionId,
    onSearch,
    refetch,
    setSecReading,
    isOwnLock,
  ]);

  useEffect(() => {
    setDisplayLockError(isErrorLock);
  }, [isErrorLock]);
  useEffect(() => {
    setDisplayUnLockError(isErrorUnLock);
  }, [isErrorUnLock]);

  return (
    <li
      onClick={async () => {
        if (isLock) {
          await handUnleLock();
        } else {
          await handleLock();
        }
      }}
    >
      <i className="fa-solid fa-pen-to-square" />
      {isLock ? t('編集解除') : t('編集')}

      {/* スピナーモーダル */}
      {isLoadinglock && <SpinnerModal />}
      {isLoadingUnlock && <SpinnerModal />}
      {/* ロック時 */}
      {displayLockError && <ErrorModal error={Errorlock} onClickOk={() => setDisplayLockError(false)} />}
      {/* アンロック時 */}
      {displayUnLockError && <ErrorModal error={ErrorUnlock} onClickOk={() => setDisplayUnLockError(false)} />}
    </li>
  );
}
export { SectionTreeMenuEdit };
